export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

type DemoRole = 'ai' | 'user' | 'system';
type DemoPlacement = 'start' | 'middle' | 'end';
type DemoVariant = 'filled' | 'outlined' | 'plain';
type DemoShape = 'round' | 'square' | 'corner';

type DemoItem = {
    key: number
    role: DemoRole
    content: string
};

type DemoRoleConfig = {
    placement: DemoPlacement
    avatar?: boolean
    roleName?: string
    variant?: DemoVariant
    shape?: DemoShape
};

interface Props {
    roles: Record<DemoRole, DemoRoleConfig>
    items: DemoItem[]
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            roles: {
                ai: {
                    placement: 'start',
                    avatar: true,
                    roleName: 'AI 助手',
                    variant: 'plain',
                },
                user: {
                    placement: 'end',
                    shape: 'corner'
                },
                system: {
                    placement: 'middle',
                    variant: 'plain',
                },
            },
            items: [
                {
                    key: 1,
                    role: 'system',
                    content: '这是您与AI助手的首次聊天',
                },
                {
                    key: 2,
                    role: 'user',
                    content: '你好，请做个自我介绍。',
                },
                {
                    key: 3,
                    role: 'ai',
                    content: '你好呀，我是AI小助手，您有什么问题都可以尽情地问我呢，我一定会尽心尽力帮您解决。',
                },
                {
                    key: 4,
                    role: 'user',
                    content: '怎么用KingDesign组件库？',
                },
            ],
        } as Props;
    }
}